export default __webpack_public_path__ + "static/cl-d9ddf35c3c2f90895d66beef9ba16982.svg";